/*
 * @Descripttion:
 * @version:
 * @Author: dengyao
 * @Date: 2022-10-17 10:17:48
 * @LastEditors: hongye
 * @LastEditTime: 2026-03-19 15:14:43
 */
import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import routerBefore from './routerBefore'
import {
  codStatisticsManage,
  packManage,
  operateManage,
  manageCenter,
  smsManagement,
  financialSettlement,
  taskCenter,
  enterpriseBank,
  configManagement,
  financialReport
} from './route'
import { NameEnum, UrlEnum, UnionEnum } from '@/utils/enums/Route'

const Layout = () => import('@/layout/index.vue')
const Login = () => import('@/views/login/Index.vue')
const Home = () => import('@/views/home/Index.vue')
const NotFound = () => import('@/views/notfound/Index.vue')
const NoAuth = () => import('@/views/noauth/Index.vue')
const I18n = () => import('@/views/i18n/Index.vue')
const routes: RouteRecordRaw[] = [
  {
    path: UrlEnum[UnionEnum.HOME],
    name: 'Layout',
    component: Layout,
    children: [
      {
        path: UrlEnum[UnionEnum.HOME],
        name: 'Home',
        component: Home,
        meta: { title: NameEnum[UnionEnum.HOME], requiresAuth: false, keepAlive: true }
      },
      {
        path: UrlEnum[UnionEnum.NOTFOUND],
        name: 'NotFound',
        component: NotFound,
        meta: { title: NameEnum[UnionEnum.NOTFOUND], requiresAuth: false, keepAlive: true }
      },
      {
        path: UrlEnum[UnionEnum.NOAUTH],
        name: 'NoAuth',
        component: NoAuth,
        meta: { title: NameEnum[UnionEnum.NOAUTH], requiresAuth: false, keepAlive: true }
      },
      {
        path: UrlEnum[UnionEnum.I18N],
        name: 'i18n',
        component: I18n,
        meta: { title: NameEnum[UnionEnum.I18N], requiresAuth: false, keepAlive: false }
      },
      ...codStatisticsManage,
      ...packManage,
      ...operateManage,
      ...manageCenter,
      ...smsManagement,
      ...financialSettlement,
      ...taskCenter,
      ...enterpriseBank,
      ...configManagement,
      ...financialReport,
      ...configManagement
    ]
  },
  {
    path: UrlEnum[UnionEnum.LOGIN],
    name: 'Login',
    component: Login,
    meta: { title: NameEnum[UnionEnum.LOGIN], requiresAuth: false, keepAlive: false }
  },
  {
    path: '/:w+',
    name: '*',
    redirect: UrlEnum[UnionEnum.NOTFOUND]
  }
]

const index = createRouter({
  history: createWebHistory(),
  routes
})
//路由导航
routerBefore(index)
export default index
